import React, { useState } from 'react';
import Button from '../components/Button';

export default function PromptDialog({
  title = 'Confirm:',
  bodytext = 'Are you sure?',
  closeDialog,
  successDialog,
  sucPrams,
  chkBoxShow = false,
  chkBoxText = '',
}) {
  const [promptVal, setPromptVal] = useState('');
  const [chkBoxVal, setChkBoxVal] = useState('0');
  return (
    <div className="modalBackground">
      <div className="logout-contnr">
        <span className="logout-hdng">{title}</span>
        <span className="logout-text tab-bg">{bodytext}</span>
        <div className="patient-search" style={{ margin: '0px 24px' }}>
          <label>Reason:</label>
          <input
            className="main-search"
            style={{ height: '34px' }}
            type="text"
            value={promptVal}
            onChange={(e) => setPromptVal(e.target.value)}
          />
        </div>
        {chkBoxShow && (
          <div style={{ margin: '5px 24px' }}>
            <input
              type="checkbox"
              value={chkBoxVal}
              onChange={(e) => setChkBoxVal(e.target.checked ? '1' : '0')}
            />{' '}
            {chkBoxText}
          </div>
        )}
        <span className="logout-action justify-end flex-sec gap10">
          <Button
            onClick={closeDialog}
            style={{ padding: '5px 30px' }}
            variant="default"
          >
            No
          </Button>
          <Button
            onClick={() => successDialog({ ...sucPrams, promptVal, chkBoxVal })}
            style={{ padding: '5px 30px' }}
            variant="primary"
          >
            Yes
          </Button>
        </span>
      </div>
    </div>
  );
}
